export default __webpack_public_path__ + "static/media/kashyap_rangani.38a9e27a.jpeg";